import { Paper, Center, Loader, Text, Stack, ThemeIcon } from "@mantine/core";
import { IconClipboardList } from "@tabler/icons-react";

import { ListWorkOrderDto } from "../../models/workorder.models";
import { useGetWorkOrdersByUserIdQuery } from "../../api/workorder.api";
import { WorkOrderListItem } from "../WorkOrders/WorkOrderListItem";

interface UserWorkOrderListProps {
	userId: string;
	onSelect?: (workOrder: ListWorkOrderDto) => void;
	selectedWorkOrderId?: string | null;
}

export const UserWorkOrderList = ({ userId, onSelect, selectedWorkOrderId }: UserWorkOrderListProps) => {
	const { data: workOrders, isLoading } = useGetWorkOrdersByUserIdQuery(userId);

	const sortedWorkOrders = workOrders?.sort((a, b) => new Date(b.Created).getTime() - new Date(a.Created).getTime()) || [];

	if (isLoading) return <>
		<Center>
			<Loader size="sm" mt="lg" />
		</Center>
	</>;

	if (!sortedWorkOrders.length) return <>
		<Stack align="center" justify="center" my="lg" px="sm">
			<ThemeIcon size={60} radius={60} color="var(--mantine-color-gray-5)" variant="light">
				<IconClipboardList size={32} />
			</ThemeIcon>
			<Text c="var(--mantine-color-gray-5)" fz="sm" style={{ textAlign: 'center' }} lineClamp={1}>There are no work orders for this user.</Text>
		</Stack>
	</>

	return (
		<Paper p={0} radius="md" style={{ overflow: 'hidden' }}>
			{sortedWorkOrders.map(workOrder => (
				<WorkOrderListItem
					key={workOrder.WorkOrderId}
					workOrder={workOrder}
					selected={selectedWorkOrderId === workOrder.WorkOrderId}
					onSelect={onSelect ? onSelect : () => { }}
					showCategories={true}
				/>
			))}
		</Paper>
	);
};
